module.exports = ".no-padding{\n    padding: 0;\n}\n\n.header{\n    font-size: 1.5rem;\n    line-height: 1.4rem;\n    color: black;\n    text-align: center;\n    padding: 1rem 0;\n}\n\n.actionButtons{\n    background-color: #009688;\n    color: #FFFFFF;\n    cursor: pointer;\n    min-width: 10rem;\n}\n\n.buttonsContainer{\n    text-align: center;\n    margin: 2rem 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog-box/dialog-box.component.css
// module id = ./src/app/dialog-box/dialog-box.component.css
// module chunks = main